import { Ref, useCallback } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { AttachArticles } from "../../../AttachArticles/AttachArticles";
import { ItemNoAndType } from "@coworker/apprestructured/src/shared/types/item";
import { useAllAttachedItems } from "@coworker/apprestructured/src/task-management/services/useAllAttachedItems";

export type AttachArticlesCreatorFragmentConfigProps = {
  field: string;
};

type AttachArticlesCreatorFragmentProps = {
  configProps: AttachArticlesCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function AttachArticlesCreatorFragment({
  configProps,
  commonProps,
}: AttachArticlesCreatorFragmentProps) {
  const { field } = configProps;
  const { blockInput, task, onTaskChange } = commonProps;
  const itemNosAndType = getByPath<ItemNoAndType[]>(task, field);

  const { items, isFetchingItems } = useAllAttachedItems(itemNosAndType);

  const handleConfirmClick = useCallback(
    (newItemNosAndType: ItemNoAndType[]) => {
      onTaskChange(setByPath(field, newItemNosAndType));
    },
    [field, onTaskChange]
  );

  if (isLoading(itemNosAndType)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <AttachArticles
      items={items}
      setItemNosAndType={handleConfirmClick}
      disabled={blockInput || isFetchingItems}
    />
  );
}

export default AttachArticlesCreatorFragment;
